module.exports = __webpack_public_path__ + "static/media/brands_KALAS.aafd022c.svg";